import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import GuessWho from './pages/GuessWho'
import TicTacToe from './pages/TicTacToe'
import GoFish from './pages/GoFish'
import BigTwo from './pages/BigTwo'
import Werewolf from './pages/Werewolf'
import Pictionary from './pages/Pictionary'
import TheMind from './pages/TheMind'
import Codenames from './pages/Codenames'
import Wavelength from './pages/Wavelength'
import ExampleGame from './pages/ExampleGame'
import { ThemeToggle } from './components/ThemeToggle'
import { SoundToggle } from './components/SoundToggle'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <ThemeToggle />
      <SoundToggle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guesswho" element={<GuessWho />} />
        <Route path="/tictactoe" element={<TicTacToe />} />
        <Route path="/gofish" element={<GoFish />} />
        <Route path="/bigtwo" element={<BigTwo />} />
        <Route path="/werewolf" element={<Werewolf />} />
        <Route path="/pictionary" element={<Pictionary />} />
        <Route path="/themind" element={<TheMind />} />
        <Route path="/codenames" element={<Codenames />} />
        <Route path="/wavelength" element={<Wavelength />} />
        <Route path="/example" element={<ExampleGame />} />
        {/* Old network route redirects to main game */}
        <Route path="/guess-who-network" element={<GuessWho />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
